import * as React from "react";
import { SVGProps } from "react";
const SvgSave1 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill={props.fill ?? "currentColor"}
      fillRule="evenodd"
      d="M27.4 8 24 4.6c-.4-.4-.9-.6-1.4-.6H8C5.8 4 4 5.8 4 8v16c0 2.2 1.8 4 4 4h16c2.2 0 4-1.8 4-4V9.4c0-.5-.2-1-.6-1.4ZM11 10V6h5v4h-5Zm7-4h3v4h-3V6Zm-7 20v-7h10v7H11Zm15-2c0 1.1-.9 2-2 2h-1v-9H9v9H8c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2h1v6h14V6.4l3 3V24Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSave1;
